
import { Building2, Columns, Factory, Leaf } from 'lucide-react';

export interface ArchitecturalStyleMatrix {
    id: string;
    name: string;
    description: string;
    prompt_modifier: string;
    icon: any;
}

export const STYLE_MATRIX: ArchitecturalStyleMatrix[] = [
    {
        id: 'modern_minimalist',
        name: 'Modern Minimalist',
        description: 'Clean lines, geometric forms, open spaces, and a focus on function.',
        prompt_modifier: 'Modern Minimalist style, ethereal white plaster, sculpting with light and shadow, museum-quality architecture, serene atmosphere, pristine geometry, highly refined detailing, golden hour lighting',
        icon: Building2
    },
    {
        id: 'neoclassical',
        name: 'Neoclassical',
        description: 'Grandeur, symmetry, columns, and classical details.',
        prompt_modifier: 'Neoclassical reinterpretation, monumental scale, cinematic composition, limestone textures, dramatic shadows, grand proportions, timeless elegance, soft diffuse lighting',
        icon: Columns
    },
    {
        id: 'industrial_lofts',
        name: 'Industrial Lofts',
        description: 'Raw materials, exposed brick, large windows, and utilitarian aesthetic.',
        prompt_modifier: 'Industrial Chic, raw material honesty, weathered textures, dramatic contrast, voluminous spaces, curated imperfection, high-end adaptive reuse, moody atmospheric lighting',
        icon: Factory
    },
    {
        id: 'bio_organic',
        name: 'Bio-Organic',
        description: 'Fluid shapes, integration with nature, and organic materials.',
        prompt_modifier: 'Bio-Organic futurism, biomimetic forms, fluid continuous surfaces, vertical forest integration, sustainable luxury, breathing architecture, soft curvilinear geometry, morning mist atmosphere',
        icon: Leaf
    }
];
